
import {
  IconButton,
  Menu,
  styled
} from "@mui/material";


export const StyledExportButton = {
  Icon: styled(IconButton)(({ theme, color }) => ({
    color: color ? color : theme.palette.primary.menuItem,
  })),
  Container: styled('div')(({ theme }) => ({
    display: "flex",
    margin: "10px"
  })),
  Menu: styled(Menu)(({ theme, color }) => ({
    marginTop: 0,
    marginLeft: 0,
  })),
}